import React, { useEffect, useState } from 'react';

import './index.scss'

interface Ipros {
    title: any,
    content: any,
    collapse: boolean,
    btnName?: any
    onMakeThisDefault?: any
    data?: any
}

const CustomAccordian = ({ title, content, collapse, btnName, onMakeThisDefault, data }: Ipros) => {

    const [isActive, setIsActive] = useState(false);

    useEffect(() => {
        setIsActive(collapse);
    }, [collapse]);

    const handleOpen = () => {
        setIsActive(!isActive)
    };
    const handleBtnClick = (e: React.MouseEvent<HTMLButtonElement>) => {
        e.stopPropagation();
        if (onMakeThisDefault) {
            onMakeThisDefault(data);
        }
    };

    return (
        <div className="custom-Accordion-base">
            <div className={`custom-Accordion-title ${isActive ? 'accordian-open' : 'accordian-close'}`} onClick={handleOpen} onKeyDown={() => { }}>
                <span className='Accordian-Title' >{title}</span>
                {btnName && (<span><button className='buttonView' title={btnName} onClick={handleBtnClick}>{btnName}</button></span>)}
                <span className={`arrow ${isActive ? 'open' : 'close'}`}></span>
            </div>
            {isActive && <div className="custom-Accordion-content">{content}</div>}
        </div>
    )
}

export default CustomAccordian;
